import {defineMessages} from "@project/i18n";

export const accessAdministrationFieldMessages = defineMessages({
  roleName: {
    id: "fields.accessRole.name",
    defaultMessage: "Role name",
    description: "Access Administration role name",
  },
  permissionKey: {
    id: "fields.accessPermission.key",
    defaultMessage: "Permission",
    description: "Access Administration permission key",
  },
});
